// To store local app state

const initialState = {
  isSidebarCollapsed: undefined,
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case 'TOGGLE_SIDEBAR':
      return {
        ...state,
        isSidebarCollapsed: !state.isSidebarCollapsed,
      }
    default:
      return state;
  }
};

export {
  reducer as app,
};

